import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

const styles = {
    documentBlock: {
        // maxWidth: 800,
        margin: "0px",
        marginTop: 5,
        // border: "1px solid #999",
        display: "flex",
        width: "100%",
        justifyContent: "center",
        // height: "90vh",
        overflow: "auto",
    }
};
const SVGViewer = ({ svgGraph, documentRef, enableZoom = true }) => {
    return (
        <div ref={documentRef} style={styles.documentBlock}>
            <TransformWrapper
                style={{ width: "100%", height: "100%" }}
                initialScale={1}
                smooth={true}
                wheel={
                    enableZoom ?
                        { step: 0.8, animationType: "easeOut" } : {
                            disabled: true, // 🔒 disables two-finger zoom
                        }}
                pinch={
                    enableZoom ?
                        { step: 0.8, animationType: "easeOut" } : {
                            disabled: true, // 🔒 disables two-finger zoom
                        }}
                doubleClick={{
                    step: enableZoom ? 0.8 : 0,
                    animationType: "easeOut",
                }}
                onTransformed={(ref, scaleState) => {
                    // handleZoom(scaleState?.scale);
                }}
            >
                <TransformComponent
                    style={{ width: "100%", height: "100%" }}
                >
                    <div
                        style={{ width: "100%", height: "100%" }}
                        dangerouslySetInnerHTML={{
                            __html: svgGraph,
                        }}
                    />

                    {/* <PdfPreview base64Data={pdf} style={{ width: '100%', height: '100%' }} /> */}
                </TransformComponent>
                {/* interpretation data */}
            </TransformWrapper>
        </div>
    )
}
export default SVGViewer